
import base from "./base.service"

const getReviewList =pilotId => base.get(`reviews/pilot/${pilotId}`)

const addReview =payload=>base.post('reviews/add',payload)

export const reviewService={
 getReviewList,
 addReview
}
